import { Component, Input, Output, EventEmitter, ViewChild , ElementRef, TemplateRef} from '@angular/core';
import { MzBaseModal } from 'ngx-materialize';
import { ZeroService } from '../../_services/zero/zero.service';
import { procesadores } from 'src/app/_models/formularios/procesadores.model';

/*
 * Modal para mensajes a usuario y envios de comentarios
 * 
 * By: jsolerh
 */
@Component({ templateUrl: './deletemodalProc.component.html'})
export class ModalsComponentDeleteProc extends MzBaseModal {
  public isOnChange: boolean;
  // datos de entrada por el servicio de modal
  @Input() public modal_title: string;
  @Input() public modal_body: string;
  @Input() public isComents: boolean = true;
  

  // Emitter para salida de comentario
  @Output() onOkModalComment:EventEmitter<String>;
  
  @ViewChild("inputComent") 
  private comentField: ElementRef;
  public modal_comentario: string;
 

  public modalOptions: Materialize.ModalOptions = {
    dismissible: false, 
    opacity: .5,
    inDuration: 300, 
    outDuration: 200, 
    startingTop: '100%', 
    endingTop: '10%'  
  };

  constructor(private zeroService: ZeroService) {     
    super(); 
    this.onOkModalComment = new EventEmitter();    
  }

  // si cancela modal emite null
  private cancelModal() {
    this.modal_comentario='';
    this.isComents= false;
    this.modalComponent.closeModal();
  }

public id: number;
public proc: procesadores;

  ngOnInit(){
    this.id;
    this.proc= new procesadores();
  }
  

  validaaccion(rowSelect: any, targetSelect: any, accion: any) 
  {
    throw new Error("Method not implemented.");
  }

   // Aceptando el modal 
  public closeModal() {
        
    // si no cometario omite esta parte
    if( this.isComents ) {
        this.modal_comentario='eliminado';
        // no deja salir si no tiene comentario 
        if( this.modal_comentario == null || this.modal_comentario == '') { 
          this.comentField.nativeElement.focus();           
          return;
        }

        this.onOkModalComment.emit(this.modal_comentario)
        this.modal_comentario ='';
        this.isComents= false;
      }
      
    this.modalComponent.closeModal();
  }
  
}

